export default __webpack_public_path__ + "static/media/PresidentBoxClosed.d8b04240.jpg";